import { RcFile } from 'antd/es/upload';
import { useMutation } from '@tanstack/react-query';
import { apiClient, ApiErrorResponse } from '../../common/ApiClient';
import { SampleUrl } from './SampleUrl';
import { expand } from 'uri-template-lite';
import { SampleDataSubjectFormDataType } from '../schema';
import { SampleSchema } from '../schema/SampleSchema';

interface IArgs {
  id: number;
  type: 'description' | 'group';
  file: string | Blob | RcFile;
  valueDate: string;
}

export const useMutateSampleUpload = (
  onProgress?: (progress: number) => void
) =>
  useMutation<SampleDataSubjectFormDataType[], ApiErrorResponse, IArgs>({
    mutationKey: ['sampleUpload'],
    mutationFn: ({ file, id, type, valueDate }) =>
      apiClient
        .post(
          expand(SampleUrl.upload, { id, type, valueDate }),
          {
            file,
          },
          {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (progress) => {
              if (!progress.total) {
                return;
              }
              onProgress?.((progress.loaded / progress.total) * 100);
            },
          }
        )
        .then((response) => SampleSchema.parseUploadedData(response.data)),
  });
